/**
 * Deja un rut en la misma forma en que el backend lo guarda: sin puntos ni
 * guion y en mayúsculas. Sirve para comparar ruts de distinto origen y para
 * referenciar a un cliente con el mismo valor que quedó almacenado.
 *
 * @param {string} valor - Rut en cualquier formato
 * @returns {string} Rut normalizado
 */
export const normalizarRut = (valor) =>
  String(valor ?? "")
    .replace(/[.-]/g, "")
    .toUpperCase();

export default normalizarRut;
